export const LABELS = {
  GOOD_TO_KNOW: 'Good to know',
  READ_MORE: 'Read more...',
};
